<div class=" container" fxFlex="100" fxLayout="row wrap" fxLayoutAlign="center center ">
  <div class="message__img" fxFlex="100" fxLayout="row wrap" fxLayoutAlign="center center ">
    <img fxFlex.xs="80" src="/assets/icons/popup__img.svg" alt="InfluenSer">
  </div>
    <div class="" fxFlex="100" fxLayout="row wrap" fxLayoutAlign="center center ">
      <span class="title | color-blue bold "  fxFlex="100">{{title}}</span>
      <button fxFlex="40" fxLayoutAlign="center center " class="button_submit | background-wine-ligth3 color-white" (click)="aceptar()">Aceptar</button>
    </div>
  </div>
  